import { F01_DARK_VIDEOS } from 'data/videos/f01/dark'
import { F01_VIDEOS } from 'data/videos/f01/default'
import { M01_DARK_VIDEOS } from 'data/videos/m01/dark'
import { M01_VIDEOS } from 'data/videos/m01/default'
import type { Funnel } from 'types/state'
import type { VideosDefinition } from 'types/videos'

type FunnelVariants = Record<string, VideosDefinition> & {
  default: VideosDefinition
}

export const DEFAULT_VIDEO_VARIANT = 'default'

export const ALL_VIDEOS = {
  chf01: { default: {} },
  chm01: { default: {} },
  f01: { default: F01_VIDEOS },
  gymf01: { default: F01_VIDEOS },
  hopif01: { default: F01_VIDEOS },
  m01: { default: M01_VIDEOS, dark: M01_DARK_VIDEOS },
  milicaf01: { default: F01_DARK_VIDEOS },
  milicam01: { default: M01_DARK_VIDEOS },
  shared: { default: {} },
  tchf01: { default: {} },
  tchm01: { default: {} },
  wallpif01: { default: F01_VIDEOS },
} as const satisfies Record<Funnel, FunnelVariants> &
  Record<string, FunnelVariants>
